import React, { useEffect, useState } from "react";
import { GridColDef, koKR } from "@mui/x-data-grid";
import { createTheme } from "@mui/material/styles";
import axios from "axios";
import { koKR as corekoKR } from "@mui/material/locale";
import { useParams } from "react-router-dom";
import {
  Container,
  Table,
  Grid,
  Paper,
  TableCell,
  tableCellClasses,
  TableRow,
} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const columns: GridColDef[] = [
  {
    field: "id",
    headerName: "id",
    width: 70,
  },
  { field: "mgm_pk", headerName: "MGM_PK", width: 230 },
  { field: "gub_age", headerName: "나이대", width: 70 },
  { field: "gub_sbj", headerName: "sub_sbj", width: 75 },
  { field: "rec_ymd", headerName: "녹음일자", width: 130 },
  { field: "seq", headerName: "일련번호", width: 270 },
];

const theme = createTheme(
  {
    palette: {
      primary: { main: "#1976d2" },
    },
    typography: {
      fontFamily: "Gmarket"
    }
  },
  koKR,
  corekoKR
);

interface rowDetailType {
  idx: number;
  mgm_pk: string;
  end_time: string;
  gub_age: string;
  gub_sbj: string;
  rec_ymd: string;
  ref_date: string;
  seq: string;
  speaker1: string;
  start_time: number;
}

const PrcWrdDetail = () => {
  let { mgm_pk } = useParams();

  const [data, setData] = useState<rowDetailType | null>(null);

  const getPrcWrdList = async () => {
    var result = await axios.get("http://localhost:9680/prcWrdDetail", {
      params: { mgm_pk: mgm_pk },
      withCredentials: true,
    });

    var datas = result.data.datas;
    console.log("datas", datas);

    setData(datas);
  };

  useEffect(() => {
    console.log("mgm_pk", mgm_pk);
    getPrcWrdList();
  }, [mgm_pk]);

  return (
    <Container sx={{ backgroundColor: "#eee", height: "85vh", width: "100%" }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>{mgm_pk}</Typography>
      <Grid container>
        <Grid item xs={8} alignItems="center" sx={{ border: "3px solid #000" }}>
          <Grid>
            <Paper sx={{ padding: 2 }}>
              {data !== null ? (
                <Table>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#bdcae7",
                          fontWeight: "bold",
                        }}
                      >
                        mgm_pk
                      </TableCell>
                      <TableCell>{data.mgm_pk}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#bdcae7",
                          fontWeight: "bold",
                        }}
                      >
                        gub_age
                      </TableCell>
                      <TableCell>{data.gub_age}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#bdcae7",
                          fontWeight: "bold",
                        }}
                      >
                        gub_sbj
                      </TableCell>
                      <TableCell>{data.gub_sbj}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#bdcae7",
                          fontWeight: "bold",
                        }}
                      >
                        rec_ymd
                      </TableCell>
                      <TableCell>{data.rec_ymd}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#bdcae7",
                          fontWeight: "bold",
                        }}
                      >
                        seq
                      </TableCell>
                      <TableCell>{data.seq}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        style={{
                          backgroundColor: "#bdcae7",
                          fontWeight: "bold",
                        }}
                      >
                        speaker1
                      </TableCell>
                      <TableCell>{data.speaker1}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              ) : ""}
            </Paper>
          </Grid>
          <Grid>
            <Paper sx={{ padding: 2 }}>wav</Paper>
          </Grid>
        </Grid>
        <Grid item xs={4} sx={{ border: "3px solid #000" }}>
          <Paper sx={{ padding: 2 }}>mgm_pk detail</Paper>
        </Grid>
      </Grid>
    </Container>
  );
};
export default PrcWrdDetail;
